import React, { Component } from "react";
import "./CustomSpinner.css";

class CustomSpinner extends Component {
  render() {
    return (
      <div className="loader">
        <div
          className="loader-background"
          style={{
            marginTop:
              this.props && this.props.marginTop ? this.props.marginTop : "0%",
          }}
        >
          <div className="custom-loader"></div>
        </div>
      </div>
    );
  }
}

export default CustomSpinner;
 /*
* @description Set Parent Div css position:relative manualy
and then add <CustomSpinner/> class
*/
